import {
  Component,
  ViewEncapsulation,
  OnInit,
  OnDestroy
} from '@angular/core';
import {
  State
} from '@progress/kendo-data-query';
import {
  DataStateChangeEvent,
  GridDataResult, SelectionEvent,
} from '@progress/kendo-angular-grid';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import {
  Observable
, Subscription} from 'rxjs';
import {
  FormControl
} from '@angular/forms';
import * as moment from 'moment';
import {Router} from '@angular/router';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {DistributorAccountsService} from './distributor-accounts.service';
import {UserContext} from '../services/user-context';



@Component({
  selector: 'app-distributor-accounts',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'distributor-accounts.template.html',
  animations: [
    trigger('slideIn', [
      state('*', style({ 'overflow-y': 'hidden' })),
      state('void', style({ 'overflow-y': 'hidden' })),
      transition('* => void', [
        style({ height: '*' }),
        animate(250, style({ height: 0 }))
      ]),
      transition('void => *', [
        style({ height: '0' }),
        animate(250, style({ height: '*' }))
      ])
    ])
  ]
})
export class DistributorAccountsComponent implements OnInit, OnDestroy {
  public view: Observable<GridDataResult>;
  public subscription: Subscription;
  public state: State = {
    skip: 0,
    take: 10
  };

  public searchText = new FormControl();

  loading = false;

  constructor(private router: Router, private service: DistributorAccountsService, private userContext: UserContext) {

    this.view = service;
    this.subscription = service.subscription;
    this.getAccounts('');
  }

  public ngOnInit(): void {
    this.searchText.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((term) => {
        if (term.length >= 3 || term.length === 0) {
          this.state.skip = 0;
          this.getAccounts(term);
        }
      });
  }

  public ngOnDestroy(): void {
  }

  public selectedRow(event: SelectionEvent) {
    this.userContext.account = event.selectedRows[0].dataItem;
    this.router.navigate(['/distributor', 'locations']);
  }

  public filterFieldChanged(): void {
    this.getAccounts(this.searchText.value || '');
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.getAccounts('');
  }

  public getAccounts(search) {
    this.loading = true;
    const page = this.state.skip / this.state.take + 1;
    const limit = this.state.take;

    this.service.getAccounts(page, limit, () => {
      this.loading = false;
    }, search);
  }

}
